
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/message-students-dialog/jst/-messageStudentsWhoRecipientList';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n  <span class=\"label\">\n    ";
  if (helper = helpers.short_name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.short_name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  </span>\n";
  return buffer;
  }

  stack1 = helpers.each.call(depth0, (depth0 && depth0.recipients), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    
      Handlebars.registerPartial('ui/shared/message-students-dialog/jst/_messageStudentsWhoRecipientList.handlebars', templates['/var/canvas/ui/shared/message-students-dialog/jst/-messageStudentsWhoRecipientList']);
    ;
    ;
    export default templates[name];
  